// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__33q7x","bigColWidth":"Table_bigColWidth__1uAl4","biggerColWidth":"Table_biggerColWidth__1rVOD","row":"Table_row__2AKlG","col":"Table_col__1t72s"};